// View-as state lives in sessionStorage so it survives page reload but dies
// when the tab closes (stops admins from forgetting they're impersonating).
//
// Shape: { user_id, email, name } — populated by AdminPage's "View as" button.

const KEY = 'onward_view_as';

export const getViewAs = () => {
  if (typeof window === 'undefined') return null;
  const raw = sessionStorage.getItem(KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const setViewAs = (target) => {
  if (typeof window === 'undefined') return;
  if (!target) {
    sessionStorage.removeItem(KEY);
  } else {
    sessionStorage.setItem(KEY, JSON.stringify(target));
  }
  // Notify same-tab listeners — "storage" event only fires cross-tab.
  window.dispatchEvent(new Event('onward:view_as_changed'));
};

export const clearViewAs = () => setViewAs(null);

// Append `?as_user_id=<id>` to a URL when view-as is active. No-op otherwise.
export const withViewAs = (url) => {
  const target = getViewAs();
  if (!target) return url;
  const sep = url.includes('?') ? '&' : '?';
  return `${url}${sep}as_user_id=${encodeURIComponent(target.user_id)}`;
};
